import authReducer from "@/redux/features/authentication/index";
import { apiSlice as adminApiSlice } from "@/services/api/baseApi";
import { apiSlice as customerApiSlice } from "@/servicescustomerside/api/baseApi";

// customerAuth is provided by @/redux/slices/customerAuthSlice in store.js
const rootReducer = {
  auth: authReducer,
  [adminApiSlice.reducerPath]: adminApiSlice.reducer,
  [customerApiSlice.reducerPath]: customerApiSlice.reducer,
};

export default rootReducer;
